var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4759 22.9382H27.4657V20.7464C27.4657 20.4528 27.2313 20.2151 26.9417 20.2151L2.0582 20.2148C1.76866 20.2148 1.5342 20.4526 1.5342 20.7461V22.938L0.524 22.9382C0.23446 22.9382 0 23.1759 0 23.4695C0 23.7631 0.23446 24.0008 0.524 24.0008H28.476C28.7655 24.0008 29 23.7631 29 23.4695C29 23.1757 28.7655 22.9382 28.476 22.9382H28.4759ZM2.58227 22.9382V21.2779H26.4182V22.9382H2.58227Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93845 18.7913H26.0644C26.3539 18.7913 26.5884 18.5536 26.5884 18.2601V15.3488C26.5884 8.76912 21.448 3.3863 15.0251 3.10669V1.06306H17.544C17.8335 1.06306 18.068 0.825345 18.068 0.53178C18.068 0.238214 17.8335 0.000494221 17.544 0.000494221L11.4585 0C11.1689 0 10.9345 0.23772 10.9345 0.531285C10.9345 0.824851 11.1689 1.06257 11.4585 1.06257L13.9773 1.06282V3.10644C7.55523 3.38593 2.41406 8.769 2.41406 15.3486V18.2598C2.41406 18.5536 2.64877 18.7913 2.93806 18.7913H2.93845ZM3.46269 15.3486C3.46269 9.17698 8.41463 4.15595 14.5019 4.15595C20.5891 4.15595 25.541 9.17673 25.541 15.3486V17.7285H3.46332L3.46269 15.3486Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell2);
export default __webpack_public_path__ + "static/media/bell-2.2ecd0606dee1a2297ce51f0a3bce72e3.svg";
export { ForwardRef as ReactComponent };